// The knives you can hold (no three.js here, so settings can import it cheaply). Every knife takes
// every finish: the blade wears the finish, its inserts the finish's accent colour.

export const KNIVES = {
  karambit: { label: 'Karambit' },
  butterfly: { label: 'Butterfly Knife' },
  m9: { label: 'M9 Bayonet' },
  skeleton: { label: 'Skeleton Knife' },
  kukri: { label: 'Kukri Knife' },
  talon: { label: 'Talon Knife' },
  bowie: { label: 'Bowie Knife' },
  stiletto: { label: 'Stiletto Knife' },
} as const;

export type KnifeKind = keyof typeof KNIVES;

export const isKnifeKind = (v: unknown): v is KnifeKind => typeof v === 'string' && v in KNIVES;
